<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 사용자 -->
				<el-col :span="6">
					<!-- <div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ label }}</span> -->

					<!-- <div class="search-option-wrapper__normal">
						<el-input v-model="searchParams.userName" @change="change" clearable></el-input>
						<i class="icon-sf-search search-icon"></i>
					</div> -->

					<!-- </div> -->
					<sf-input-group
						:label="getMessage_('MWCC000017')"
						:inputValue="searchParams.userName"
						:onChange="value => onChangeSearchParam({ key: 'userName', value })"
					/>
				</el-col>
				<!-- 부서명 -->
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('QWCC001153')"
						:inputValue="searchParams.deptName"
						:onChange="value => onChangeSearchParam({ key: 'deptName', value })"
					/>
					<!-- <search-input :label="getMessage_('MWCC000337')" paramKey="msgKey" ref="searchMsgKey" /> -->
				</el-col>
				<!-- 비고 -->
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('SWCC000407')"
						:inputValue="searchParams.remark"
						:onChange="value => onChangeSearchParam({ key: 'remark', value })"
					/>
					<!-- <search-input :label="getMessage_('MWCC000338')" paramKey="msgText" ref="searchMsgText" /> -->
				</el-col>
				<el-col :span="6">
					<!-- <msgLoc-select ref="searchMsgLoc" @reload="searchList()" /> -->
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/UserPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
		//userName: { type: String, default: '' }
	},
	async created() {
		await this.searchList();
	},
	data() {
		return {
			// userPopupParams: {
			// 	userName: this.userName,
			// 	userId: ''
			// }
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		searchList() {
			// console.log('UserpopSearchView 에서 searchList 실행');
			// this.userPopupParams.userName = param.userName;
			this.$sf_toggleLoading(true);
			this.getPopupUsers_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onUserPopupParams(param) {
			// console.log('UserpopSearchView 에서 setParams 실행', param);
			this.searchParams.userName = param.userName;
		},
		reset() {
			// console.log('UserpopSearchView 에서 reset 실행');
			this.searchParams.userName = '';
		},
		onChangeSearchParam({ key, value }) {
			this.searchParams[key] = value;
		}
	}
};
</script>

<style></style>
